import React, { useState } from 'react';
import { Link } from 'react-router';
import { animateScroll } from 'react-scroll';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import CastSlider from './CastSlider';
import CastOverlay from './CastOverlay';
import Divider from '../Divider';
import Style from './Cast.module.scss';

const Cast = ({
  castInfo,
  disableScroll,
  breakpoint,
  contentCode,
  isCast = true,
  setCastArray,
}) => {
  const [castDetail, setCastDetail] = useState(null);

  const { tileGrid_seeAllButtonText: seeAllText } = window.Language;

  return (
    castInfo &&
    Object.keys(castInfo).map(key => (
      <>
        <section className={Style.castContainer}>
          <h2 className={Style.castHeader}>{`Meet the ${castInfo[key][0].category}`}</h2>
          <Link
            className={Style.seeAllButton}
            to={`/${contentCode}/${isCast ? 'credits' : 'characters'}/`}
            onClick={() => {
              setCastArray(castInfo[key]);
              animateScroll.scrollToTop({ duration: 500 });
            }}
          >
            {seeAllText}
            <Icon color="white" size="medium" viewBox="0 0 18 32" icon="ios-arrow-right" />
          </Link>
          <CastSlider
            castArray={castInfo[key]}
            setCastDetail={setCastDetail}
            disableScroll={disableScroll}
            breakpoint={breakpoint}
          />
          <CastOverlay
            breakpoint={breakpoint}
            castInfo={castInfo}
            castDetail={castDetail}
            setCastDetail={setCastDetail}
            disableScroll={disableScroll}
          />
        </section>
        <Divider />
      </>
    ))
  );
};

Cast.propTypes = {
  breakpoint: PropTypes.string,
  castArray: PropTypes.arrayOf(PropTypes.shape({})),
  disableScroll: PropTypes.func,
  contentCode: PropTypes.string,
  isCast: PropTypes.bool,
  setCastArray: PropTypes.func,
};

export default React.memo(Cast);
